export default function adminAuthHeader() {
    let admin = JSON.parse(localStorage.getItem("sportips_auth_admin"));
    if (admin && admin.token) {
        return { Authorization: 'Bearer ' + admin.token };
    }
    else {
        return {};
    }
}